import styled from "styled-components"


const OracleInput = styled.input`
    color: ${({ theme }) => theme.panelTextColor};
    background-color: ${({ theme }) => theme.inputPanelBackgroundColor};

	width: ${({ width }) => width};
	border: none;
	font-size: 1em;
	text-align: right;

	align-items: center;
	margin: .2em;
    padding: 0.25em;
    selection: none;

    border-radius: 0.5em;

	&:hover {
		outline: none;
	}

	&:active {
		outline: none;
	}

	&:focus {
		outline: none;

	}

   &::placeholder {
       color: #CCC;
   }

	/* Tablets */
	@media (max-width: 1400px) {
		font-size: 1em;
		padding: 0.em;
		max-width: 80%;
	}

	/* Mobiles */
	@media (max-width: 640px) {
		font-size: 0.75em;
		padding: 0.em;
		width: 90%;
	}
`;



export default OracleInput;
